export const MESSAGE_LOADING = "MESSAGE_LOADING";
export const MESSAGE_ADD = "MESSAGE_ADD";
export const MESSAGE_UPDATE = "MESSAGE_UPDATE";
export const MESSAGE_DELETE = "MESSAGE_DELETE";
export const MESSAGE_FILTERS = "MESSAGE_FILTERS";
export const MESSAGE_LIST = "MESSAGE_LIST";



// WEBPACK FOOTER //
// ./src/actions/message/types.js